import { cTrackingListener } from './utils/helpers';
import { BasePayload } from './types';

/**
 * Track successful account creation and trigger associated metrics.
 * Note: No Pensieve lead is fired here - the backend emits USER_CREATED on account creation.
 */
export const accountCreationTracking = ({ country }: BasePayload) => {

  // Capterra
  cTrackingListener();

  // Bing
  if (country === 'GB' || country === 'US') {
    window.uetq = window.uetq || [];
    window.uetq.push('event', '', { event_label: 'Form complete' });
  }
};
